import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  getTradeInCalculatorHeadline,
  getTradeInCalculatorHeadlineTagName,
  getTradeInCalculatorTitle,
  getTradeInCalculatorFootnote,
  getTradeInCalculatorOptions,
  getTradeInCalculatorMaxPrice,
  getTradeInCalculatorWaitStatus,
  getTradeInCalculatorErrorStatus,
  getTradeInCalculatorErrorText,
  getTradeInCalculatorButtonHref,
} from 'store/widgets/TradeInCalculator/selectors';
import { getDeviceTypes, selectDeviceOption } from 'store/widgets/TradeInCalculator/actions';
import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import TradeInCalculatorWidgetLayout from 'components/TradeInCalcWidgetLayout';

const mapStateToProps = (state) => ({
  headline: getTradeInCalculatorHeadline(state),
  headlineTagName: getTradeInCalculatorHeadlineTagName(state),
  title: getTradeInCalculatorTitle(state),
  footNote: getTradeInCalculatorFootnote(state),
  isMobile: isScreenBelow640(state),
  optionsList: getTradeInCalculatorOptions(state),
  maxPrice: getTradeInCalculatorMaxPrice(state),
  isWait: getTradeInCalculatorWaitStatus(state),
  error: getTradeInCalculatorErrorText(state),
  hasError: getTradeInCalculatorErrorStatus(state),
  buttonHref: getTradeInCalculatorButtonHref(state),
});

const mapDispatchToProps = {
  getTypes: getDeviceTypes,
  selectOption: selectDeviceOption,
};

const TradeInCalculatorWidget = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TradeInCalculatorWidgetLayout);

TradeInCalculatorWidget.propTypes = {
  headline: PropTypes.string,
  headlineTagName: PropTypes.string,
  title: PropTypes.string,
  footNote: PropTypes.string,
  isMobile: PropTypes.bool,
  getTypes: PropTypes.func,
  optionsList: PropTypes.array,
  selectOption: PropTypes.func,
  maxPrice: PropTypes.string,
  isWait: PropTypes.bool,
  hasError: PropTypes.bool,
  error: PropTypes.string,
  buttonHref: PropTypes.string,
};

export default TradeInCalculatorWidget;
